/* eslint-disable */

export enum Icon {
  /** TRENDING_ARROW - Icon for trending boost */
  TRENDING_ARROW = "TRENDING_ARROW",
  /** MAX_UP_ARROW - Icon for Max. Discount criterion */
  MAX_UP_ARROW = "MAX_UP_ARROW",
  /** CLOCK - Icon for expiration countdown */
  CLOCK = "CLOCK",
  /** LOCK - Icon for locked boost */
  LOCK = "LOCK",
  /** PRICE_TAG - Icon for Min. Purchase criterion */
  PRICE_TAG = "PRICE_TAG",
  /** RECURRING_ARROW - Icon for Uses Remaining criterion */
  RECURRING_ARROW = "RECURRING_ARROW",
  /** RATE_LIMITING_PAUSE - Icon for Rate Limiting */
  RATE_LIMITING_PAUSE = "RATE_LIMITING_PAUSE",
  /** UNLOCKED - Icon for Unlocked detail */
  UNLOCKED = "UNLOCKED",
  /** PLAY - Icon for Started Progress detail */
  PLAY = "PLAY",
  /** CARD - Icon for Cash Card only detail */
  CARD = "CARD",
  /** GLOBE - Icon for Online Only detail */
  GLOBE = "GLOBE",
}
